import { useEffect, useState } from "react";
import { Text } from "../Text";
import { fetchWhiteLabelCompany } from "../../reducers/whitelabelSlices";
import { useDispatch } from "react-redux";
function Footer() {
  const [termsUrl, setTermsUrl] = useState("");
  const [rightsUrl, setRightsUrl] = useState("");
  const dispatch = useDispatch();
  const fetchData = async () => {
    try {
      const res = await dispatch(fetchWhiteLabelCompany()).unwrap();
      if (res?.success) {
        setRightsUrl(res?.data?.rights || "");
        setTermsUrl(res?.data?.termsConditionLink || "");
      }
    } catch (error) {
      console.error("Failed to fetch white label data:", error);
    }
  };
  useEffect(() => {
    fetchData();
  }, [dispatch]);
  return (
    <div className="py-3 px-5" style={{ borderTop: "1px solid #E1E1EA" }}>
      <div className="flex flex column md:flex-row lg:flex-row xl:flex-row align-items-center  justify-content-center md:justify-content-between lg:justify-content-between xl:justify-content-between gap-1 flex-wrap">
        <Text type={"small-text"} color={"#5E5E72"}>
          <span>
            &copy; {new Date().getFullYear()} {rightsUrl || "Deskala"}, All
            Rights Reserved.
          </span>
        </Text>
        <Text type={"small-text"}>
          <a
            href={termsUrl || "https://skalebot.com/termsandconditions"}
            target="_blank"
            rel="noreferrer"
            style={{ color: "#5E5E72", textDecoration: "none" }}
          >
            Terms & Conditions  {termsUrl ? '' : "| skalebot.com"}
          </a>
        </Text>
      </div>
    </div>
  );
}

export default Footer;
